<template>
  <div>
    <v-row class="pl-6 pr-6 mr-6 ml-6">
      <!--Incoming messages-->
      <v-col md="6" v-for="item in userComments" :key="item.id" class="pr-12 pl-12 pb-0 mb-0 mt-0 pt-0">
        <v-card class="mx-auto" height="100%">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">{{item.title}}</v-list-item-title>
              <v-list-item-subtitle class="subtitle-2">{{item.uploaded}}</v-list-item-subtitle>
              <v-divider></v-divider>
              <v-row>
                <v-col md="12">
                  <span>{{item.message}}</span>
                </v-col>
                <v-col md="12">
                  <span class="subtitle-1 pr-5 error--text" style="cursor: pointer;">Report</span>
                  <span class="subtitle-1 pr-5 success--text" style="cursor: pointer;">Hide</span>
                  <span class="subtitle-1 primary--text" style="cursor: pointer;">Reply</span>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-divider></v-divider>
          <v-divider></v-divider>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data(){
    return{
      // Inbox message
      userComments:[
        {id:1, username:"Bob", title:"Inspiring content", uploaded:"2020.01.01", message:"Best content evah! That brah, is some TED Talk content right there!"},
        {id:2, username:"Neighbour Kate", title:"Life changing article", uploaded:"2020.01.01", message:"After reading about your article regarding waste of soup, i began keeping it in a bag with me.  #noWasteSoup"},
        {id:3, username:"Rich prince", title:"Want 11 mill?", uploaded:"2020.01.01", message:"You want moneh?. I got moneh.  You give me account, i share the moneh."},
        {id:4, username:"Wifey", title:"Fishy for dinner", uploaded:"2020.01.01", message:"Fish for dinner. Dont be late! Buy some garlic from the shop."},
        {id:5, username:"Smokey Jane", title:"Tip for an article", uploaded:"2020.01.01", message:"This didnt come from me, but those mole people are active again. Pls checkout the tunnels at risky-area 51"},
      ]
    }
  }
}
</script>